import React from 'react';
import PageTransition from '../../components/PageTransition';
import SafeIcon from '../../common/SafeIcon';
import { FiLayout, FiList } from 'react-icons/fi';

const Setup = () => {
  return (
    <PageTransition className="p-8 max-w-5xl mx-auto">
      <div className="mb-8 border-b border-gray-200 pb-6">
        <h1 className="text-2xl font-bold text-gray-900">Project Setup</h1>
        <p className="text-gray-500 text-sm mt-1">Configure your screener questions and build interview modules.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Screener Builder Scaffold */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col h-[500px]">
          <div className="p-5 border-b border-gray-100 bg-gray-50/50 flex items-center gap-3">
            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
              <SafeIcon icon={FiList} />
            </div>
            <div>
              <h2 className="font-semibold text-gray-900">Screener Builder</h2>
              <p className="text-xs text-gray-500">Qualify participants</p>
            </div>
          </div>
          <div className="flex-1 p-6 flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
              <SafeIcon icon={FiList} className="text-2xl text-gray-400" />
            </div>
            <h3 className="text-gray-900 font-medium mb-2">No screener questions yet</h3>
            <p className="text-sm text-gray-500 mb-6 max-w-[250px]">
              Add questions to filter and segment your incoming participants.
            </p>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm">
              Add Question
            </button>
          </div>
        </div>

        {/* Module Builder Scaffold */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col h-[500px]">
          <div className="p-5 border-b border-gray-100 bg-gray-50/50 flex items-center gap-3">
            <div className="p-2 bg-purple-50 text-purple-600 rounded-lg">
              <SafeIcon icon={FiLayout} />
            </div>
            <div>
              <h2 className="font-semibold text-gray-900">Module Builder</h2>
              <p className="text-xs text-gray-500">Design interview activities</p>
            </div>
          </div>
          <div className="flex-1 p-6 flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
              <SafeIcon icon={FiLayout} className="text-2xl text-gray-400" />
            </div>
            <h3 className="text-gray-900 font-medium mb-2">No modules created</h3>
            <p className="text-sm text-gray-500 mb-6 max-w-[250px]">
              Create interactive modules like card sorts, journey maps, or prototypes.
            </p>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm">
              Create Module
            </button>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default Setup;